import type { Banner, BannerQueryOptions } from '@/types';
import { useQuery } from 'react-query';
import client from './client';
import { API_ENDPOINTS } from './client/api-endpoints';

export function useBanner(options?: Partial<BannerQueryOptions>) {
  const formattedOptions: Partial<BannerQueryOptions> = {
    for: 'web',
    is_global: true,
    ...options,
  };

  const { data, isLoading, error } = useQuery<Banner[], Error>(
    [API_ENDPOINTS.BANNERS, formattedOptions],
    () => client.banners.all(formattedOptions),
    {
      // staleTime: Infinity,
      // cacheTime: Infinity,
    },
  );

  return {
    banners: data ?? [],
    isLoading,
    error,
  };
}
